import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-no-access',
  imports: [],
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.css',
})
export class NoAccessComponent {}
